import React, { Component } from 'react';
import { Navbar } from 'react-bootstrap';
import Log from 'services/Log.jsx'
import { Grid, Col, Row, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import Switch from 'react-bootstrap-switch';
import Card from 'components/Card/Card.jsx';
import Button from 'elements/CustomButton/CustomButton.jsx';
import { Authenticator } from 'services/AuthService.jsx'

var mqtt = require('mqtt');
var classNames = require('classnames');

let x = 1;
let statusInfo = "N/A";
let mqttClient = null;
let logHistory = [];

class DemoWidget extends Component{
    constructor(props){
        super(props);
        this.state = {
          'top':16,
          ys:[],
          intervalId: null,
          sampleId: null,
          speed: 35,
          amplitude: 5,
          count: 3,
          currentValue: 0,
          samplePeriod: 1,
          sampleValue: 0,
          doSample: true,
          connected: false,
          clientName: "Demo Client",
          metricName: "Demo Metric",
          metricError: "",
          clientError: "",
          mqttClient: null,
          selected_project : {},
          samplerState: true
        };
        this.handleGeneric = this.handleGeneric.bind(this);
        this.handleSwitch = this.handleSwitch.bind(this);
    }

    componentDidMount(props) {
      Log.debug("[DemoWidget] mounting");
      this.initiGeneration();
      this.initSampling();
      this.refreshData();
    }

    refreshData() {
      Authenticator.getUser((user) => {
        Log.debug("[RD] " + JSON.stringify(user));
        this.setState({selected_project: user.selectedProject});
      });
    }

    initiGeneration(initSpeed) {
      var speed = initSpeed || this.state.speed;
      var component = this;
      var period = 20;
      var count = period * component.state.count;
      var dx = (2*Math.PI / period);
      var intervalId = setInterval(function(){
        let newYs = component.calc(dx, component.state.amplitude, period * component.state.count);
         component.setState({'ys': newYs, currentValue: newYs[newYs.length - 1]});
       }, speed);
      component.setState({intervalId:intervalId, speed: speed});
    }

    sendDatapoint(datapoint) {
      if (mqttClient && this.state.connected) {
        Log.debug("Sending datapoint");
        let message = {
          metric: this.state.metricName,
          timestamp: Date.now(),
          tags: {},
          value: datapoint
        };
        Log.debug("message: " + JSON.stringify(message));
        logHistory.push(message);
        mqttClient.publish(this.state.selected_project.apiKey, JSON.stringify(message), {qos: 1});
      }
    }

    initSampling(initSpeed) {
      var samplePeriod = initSpeed || this.state.samplePeriod;
      var component = this;
      var sampleId = setInterval(function(){
        if (component.state.doSample) {
          component.sendDatapoint(component.state.currentValue);
          component.setState({sampleValue: component.state.currentValue, samplerState: true});
          setTimeout(function(){
            component.setState({samplerState: false});
          }, 300);
        }
       }, samplePeriod * 1000);
      component.setState({sampleId:sampleId, samplePeriod: samplePeriod});
    }

    componentWillUnmount(){
      clearInterval(this.state.intervalId);
      clearInterval(this.state.sampleId);
      if (mqttClient) {
        mqttClient.end();
        mqttClient = null;
      }
    }

    handleSwitch(element, state) {
      Log.debug(element);
      Log.debug(state);
      let name = element.props.name;
      let value = state;
      this.setState({[name]: value});
    }

    dgConnect() {
      if (!this.state.connected) {
        if (this.state.clientName.length > 0 && this.state.metricName.length > 0) {
          Log.debug("Connecting");
          mqttClient = mqtt.connect('wss://ws.datagekko.com/ws', {port:443, username: this.state.selected_project.apiKey, password: this.state.selected_project.tmpsecret, clientId: this.state.clientName});
          var self = this;
          statusInfo = "Connecting"
          mqttClient.on('connect', function () {
              statusInfo = "N/A"
              self.setState({connected: true, metricError: "", clientError: ""});
          });
        } else {
          Log.debug("Error");
          let metricError = "";
          let clientError = "";
          if (this.state.metricName.length < 1) {
            Log.debug("Error metric name");
            metricError = (<small className="text-danger">Metric must have a name.</small>);
          }
          if (this.state.clientName.length < 1) {
            Log.debug("Error client name");
            clientError = (<small className="text-danger">Client must have a name.</small>);
          }
          if (metricError && clientError) {
            this.setState({metricError: metricError, clientError: clientError});
          } else if (clientError) {
            this.setState({clientError: clientError, metricError: ""});
          } else if (metricError) {
            this.setState({clientError: "", metricError: metricError});
          }
        }
      } else {
        if (mqttClient) {
          mqttClient.end();
          mqttClient = null;
          this.setState({connected: false, metricError: "", clientError: ""});
        }
      }
    }

    handleGeneric(event) {
      let name = [event.target.name];
      let value = event.target.value;
      if (name == "samplePeriod") {
        if (value < 1) {
          value = 1;
        }
        if (value > 3600) {
          value = 3600;
        }
        clearInterval(this.state.sampleId);
        this.initSampling(value);
      } else if (name == "amplitude") {
        Log.debug("amplitude update " + value);
        if (value < 0) {
          value = 0;
        }
        if (value > 15) {
          value = 15;
        }
        this.setState({[name]: value});
      } else if (name == "count") {
        if (value < 1) {
          value = 1;
        }
        if (value > 50) {
          value = 50;
        }
        this.setState({[name]: value});
      } else if (name == "speed") {
        if (value < 1) {
          value = 1;
        }
        if (value > 5000) {
          value = 5000;
        }
        clearInterval(this.state.intervalId);
        this.initiGeneration(value);
      } else {
        Log.debug("generic update for " + name);
        this.setState({[name]: value});
      }
    }

    calc(dx, amplitude, count){
      var component = this;
      var ys = [];
      for (var i = 0; i <=count; i++){
        ys.push(Math.sin(x) * amplitude);
        x += dx;
      }
      return ys;
    }

    render(){
      var component = this;
        return (
          <Card
            title="Demo Signal"
            category="To modify the signal and capture data use the provided controls"
            content={
              <Row>
                <Row>
                  <Col md={12}>
                    <div id="signal-container">
                      <div className="loader">
                      {
                        this.state.ys.map(function(y, x) {
                          return <div key={x}>
                              <div style={{'top':y + component.state.top + 'vh'}}>
                              </div>
                            </div>
                          })
                      }
                      <div className={classNames({'sampler-cue': true, 'sampler-cue-in': this.state.samplerState, 'sampler-cue-out': !this.state.samplerState})}></div>
                      </div>
                      <div className="sampler-meta">
                        <div className="sampler-meta-zero">
                          <div>0</div>
                        </div>
                        <div className="sampler-meta-amp">
                          <div className="amp-top-3">15</div>
                          <div className="amp-top-2">10</div>
                          <div className="amp-top-1">5</div>
                          <div className="neg-amp-top-1">-5</div>
                          <div className="neg-amp-top-2">-10</div>
                          <div className="neg-amp-top-3">-15</div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <h4 className="controls-title">Signal Controls</h4>
                  </Col>
                  <Col md={6}>
                    <div className="demo-controls">
                      <FormGroup>
                        <ControlLabel>
                            Signal generator period (ms)
                        </ControlLabel>
                        <FormControl
                            placeholder="Signal generator period (ms)"
                            type="number"
                            name="speed"
                            value={this.state.speed}
                            onChange={this.handleGeneric}
                        />
                        <ControlLabel>
                            Signal amplitude
                        </ControlLabel>
                        <FormControl
                            placeholder="Signal amplitude"
                            type="number"
                            name="amplitude"
                            value={this.state.amplitude}
                            onChange={this.handleGeneric}
                        />
                        <ControlLabel>
                            Datapoint count multiplier
                        </ControlLabel>
                        <FormControl
                            placeholder="Count multiplier"
                            type="number"
                            name="count"
                            value={this.state.count}
                            onChange={this.handleGeneric}
                        />
                      </FormGroup>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="demo-controls">
                      <FormGroup>
                        <ControlLabel>
                            Sample period (s)
                        </ControlLabel>
                        <FormControl
                            placeholder="Sample period (s)"
                            type="number"
                            name="samplePeriod"
                            value={this.state.samplePeriod}
                            onChange={this.handleGeneric}
                        />
                        <ControlLabel>
                            Data sampling
                        </ControlLabel>
                        <br/>
                        <Switch
                            onText="✔"
                            offText="✘"
                            name="doSample"
                            defaultValue={this.state.doSample}
                            onChange={this.handleSwitch}
                        />
                      </FormGroup>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <h4 className="controls-title">Client Controls</h4>
                  </Col>
                  <Col md={6}>
                    <div className="demo-controls">
                      <FormGroup>
                        <ControlLabel>
                            Client Name
                        </ControlLabel>
                        <FormControl
                            placeholder="Client Name"
                            type="text"
                            name="clientName"
                            value={this.state.clientName}
                            onChange={this.handleGeneric}
                        />
                        {this.state.clientError}
                      </FormGroup>
                    </div>
                    <Button bsStyle={this.state.connected ? "warning" : "success"} className="btn-fill demo-client-button" wd onClick={this.dgConnect.bind(this)}>
                        {this.state.connected ? "Disconnect" : "Connect"}
                    </Button>
                  </Col>
                  <Col md={6}>
                    <div className="demo-controls">
                      <FormGroup>
                        <ControlLabel>
                            Metric Name
                        </ControlLabel>
                        <FormControl
                            placeholder="Metric Name"
                            type="text"
                            name="metricName"
                            value={this.state.metricName}
                            onChange={this.handleGeneric}
                        />
                        {this.state.metricError}
                      </FormGroup>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="log-console">
                      Current log value: {this.state.sampleValue}<br/>
                      Client status: {this.state.connected ? "Connected" : "Not Connected"}<br/>
                      App state: {statusInfo}
                      <div className="log-messages">
                        {
                          [...logHistory].reverse().map(function (message, key) {
                            return <div className="log-item" key={key}>{JSON.stringify(message)}</div>
                          })
                        }
                      </div>
                    </div>
                    <div className="controls-title">Visualize your data in the data explorer.</div>
                  </Col>
                </Row>
              </Row>
            }
          />
        );
    }
}

export default DemoWidget;



// WEBPACK FOOTER //
// ./src/components/DemoWidget/DemoWidget.jsx